<div class="loader-container" *ngIf="!errorMessage">
  <img class="loading-gif" src="../assets/Coffeeloader.svg" alt="loading">
</div>

<div class="square-oauth-error" *ngIf="errorMessage">
  <h2>Square sign-in</h2>
  <p>{{ errorMessage }}</p>
  <p>You will be returned to the login screen shortly.</p>
</div>
